export default __webpack_public_path__ + "e1d699e6544d0dbf6ec7a6f6db43aef7.ttf";